export const HOME = {
  emergentLink: "home-emergent-link",
  navBookBtn: "nav-book-btn",
  navAdminBtn: "nav-admin-btn",
  heroBookBtn: "hero-book-btn",
  heroQuoteBtn: "hero-quote-btn",
};

export const QUOTE = {
  homeSize: "quote-home-size",
  moveType: "quote-move-type",
  distance: "quote-distance",
  packing: "quote-extra-packing",
  unpacking: "quote-extra-unpacking",
  piano: "quote-extra-piano",
  antiques: "quote-extra-antiques",
  storage30: "quote-extra-storage30",
  submit: "quote-submit-btn",
  resultLow: "quote-result-low",
  resultHigh: "quote-result-high",
};

export const BOOKING = {
  fullName: "booking-full-name",
  email: "booking-email",
  phone: "booking-phone",
  moveType: "booking-move-type",
  homeSize: "booking-home-size",
  originCity: "booking-origin-city",
  originState: "booking-origin-state",
  destCity: "booking-dest-city",
  destState: "booking-dest-state",
  moveDate: "booking-move-date",
  notes: "booking-notes",
  submit: "booking-submit-btn",
  success: "booking-success",
};

export const CALLBACK = {
  fullName: "callback-name",
  phone: "callback-phone",
  email: "callback-email",
  bestTime: "callback-best-time",
  message: "callback-message",
  submit: "callback-submit-btn",
  success: "callback-success",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  bookingsTable: "admin-bookings-table",
  statRow: "admin-stat-row",
};
